var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"env-charts",style:({ height: _vm.height })},[_c('div',{ref:"charts",style:({ height: _vm.height, width: '100%' })}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }